function skylineCirclesDocumentLoad() {

  /* Prevent duplicate global listeners if this asset
     appears more than once through Shopify sections. */
  if (window.__skylineCirclesInitialized) {

    if (window.__skylineCirclesBoot) {
      window.__skylineCirclesBoot(document);
    }

    return;
  }

  window.__skylineCirclesInitialized = true;


  const CDN_JS =
    'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';

  const CDN_CSS =
    'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';


  let swiperLoader = null;

  const managedSections = new Set();


  /* =========================================================
     LOAD SWIPER
  ========================================================= */

  function loadSwiper() {

    if (window.Swiper) {
      return Promise.resolve(window.Swiper);
    }


    if (swiperLoader) {
      return swiperLoader;
    }


    swiperLoader = new Promise(function (resolve, reject) {


      /* Load CSS once */
      if (
        !document.querySelector(
          'link[href*="swiper-bundle.min.css"]'
        )
      ) {

        const css =
          document.createElement('link');

        css.rel = 'stylesheet';

        css.href = CDN_CSS;

        css.setAttribute(
          'data-skyline-swiper-css',
          ''
        );

        document.head.appendChild(css);
      }


      /* Check existing script */
      const existingScript =
        document.querySelector(
          'script[src*="swiper-bundle.min.js"]'
        );


      if (existingScript) {

        if (window.Swiper) {

          resolve(window.Swiper);

          return;
        }


        let checks = 0;


        const timer =
          window.setInterval(function () {

            checks += 1;


            if (window.Swiper) {

              window.clearInterval(timer);

              resolve(window.Swiper);

            } else if (checks >= 50) {

              window.clearInterval(timer);

              reject(
                new Error(
                  'Swiper loading timed out.'
                )
              );
            }

          }, 100);


        return;
      }


      /* Create script */
      const script =
        document.createElement('script');


      script.src = CDN_JS;

      script.async = true;


      script.setAttribute(
        'data-skyline-swiper-js',
        ''
      );


      script.onload = function () {

        if (window.Swiper) {

          resolve(window.Swiper);

        } else {

          reject(
            new Error(
              'Swiper loaded but window.Swiper is unavailable.'
            )
          );
        }
      };


      script.onerror = function () {

        reject(
          new Error(
            'Swiper failed to load.'
          )
        );
      };


      document.head.appendChild(script);

    });


    return swiperLoader;
  }



  /* =========================================================
     HELPERS
  ========================================================= */

  function isMobile() {

    return window.matchMedia(
      '(max-width: 749px)'
    ).matches;
  }


  function needsSlider(section) {

    if (isMobile()) {

      return (
        section.dataset.mobileLayout ===
        'slider'
      );
    }


    return (
      section.dataset.desktopLayout ===
      'slider'
    );
  }


  function getCssNumber(
    section,
    variableName,
    fallback
  ) {

    const value =
      parseFloat(
        window
          .getComputedStyle(section)
          .getPropertyValue(variableName)
      );


    return Number.isFinite(value)
      ? value
      : fallback;
  }



  /* =========================================================
     SLIDES PER VIEW
  ========================================================= */

  function getSlidesPerView(section) {
    const slider = section.querySelector('[data-swiper]');
    const width = slider ? slider.getBoundingClientRect().width : window.innerWidth;
    const mobileColumns = Math.max(1, Math.floor(getCssNumber(section, '--sc-grid-cols-mobile', 2)));
    const tabletColumns = Math.max(1, Math.floor(getCssNumber(section, '--sc-grid-cols-tablet', 4)));
    const desktopColumns = Math.max(1, Math.floor(getCssNumber(section, '--sc-grid-cols-desktop', 6)));
    const requestedColumns = width < 750
      ? mobileColumns
      : width < 990
        ? tabletColumns
        : desktopColumns;

    // Swiper cannot move if every collection card is already visible.
    // Keep at least one card off-screen whenever there are two or more cards.
    const slideCount = section.querySelectorAll('.skyline-circles__slide').length;
    return slideCount > 1
      ? Math.min(requestedColumns, slideCount - 1)
      : 1;
  }

  function getSpaceBetween(section) {

    if (isMobile()) {

      return getCssNumber(
        section,
        '--sc-gap-mobile',
        12
      );
    }


    return getCssNumber(
      section,
      '--sc-gap-desktop',
      18
    );
  }



  /* =========================================================
     VISUAL LOADING / REVEAL
  ========================================================= */

  function setVisualLoading(section) {

    if (!section) {
      return;
    }


    section.classList.remove(
      'skyline-circles--visual-ready'
    );


    section.classList.add(
      'skyline-circles--visual-loading'
    );
  }



  function revealSection(section) {

    if (!section) {
      return;
    }


    window.requestAnimationFrame(
      function () {

        if (
          !document.documentElement.contains(
            section
          )
        ) {
          return;
        }


        section.classList.remove(
          'skyline-circles--visual-loading'
        );


        section.classList.add(
          'skyline-circles--visual-ready'
        );

      }
    );
  }



  function waitForVisibleImages(section) {

    if (!section) {
      return Promise.resolve();
    }


    const visibleCount =
      Math.max(
        1,
        Math.ceil(
          getSlidesPerView(section)
        )
      );


    const images =
      Array.from(
        section.querySelectorAll(
          '.skyline-circles__slide .skyline-circles__image'
        )
      ).slice(
        0,
        visibleCount
      );


    if (!images.length) {
      return Promise.resolve();
    }


    const imagePromises =
      images.map(
        function (image) {

          /*
           * Only first visible row is promoted.
           * Remaining collection images stay lazy.
           */
          if (
            image.loading ===
            'lazy'
          ) {

            image.loading =
              'eager';
          }


          if (
            image.complete &&
            image.naturalWidth > 0
          ) {

            if (
              typeof image.decode ===
              'function'
            ) {

              return image
                .decode()
                .catch(
                  function () {}
                );
            }


            return Promise.resolve();
          }


          return new Promise(
            function (resolve) {

              let finished =
                false;


              const done =
                function () {

                  if (finished) {
                    return;
                  }


                  finished =
                    true;


                  image.removeEventListener(
                    'load',
                    done
                  );


                  image.removeEventListener(
                    'error',
                    done
                  );


                  if (
                    typeof image.decode ===
                      'function' &&
                    image.complete &&
                    image.naturalWidth > 0
                  ) {

                    image
                      .decode()
                      .catch(
                        function () {}
                      )
                      .finally(
                        resolve
                      );


                    return;
                  }


                  resolve();
                };


              image.addEventListener(
                'load',
                done,
                {
                  once: true
                }
              );


              image.addEventListener(
                'error',
                done,
                {
                  once: true
                }
              );

            }
          );

        }
      );


    /*
     * Do not make the section feel slow
     * because of one slow image.
     */
    const timeout =
      new Promise(
        function (resolve) {

          window.setTimeout(
            resolve,
            180
          );

        }
      );


    return Promise.race(
      [
        Promise.all(
          imagePromises
        ),

        timeout
      ]
    );
  }



  /* =========================================================
     CLEAN SWIPER STYLES
  ========================================================= */

  function clearSwiperStyles(section) {

    const slider =
      section.querySelector(
        '[data-swiper]'
      );


    const track =
      section.querySelector(
        '.skyline-circles__track'
      );


    if (slider) {

      slider.classList.remove(
        'swiper-initialized',
        'swiper-horizontal',
        'swiper-backface-hidden'
      );


      slider.removeAttribute('style');
    }


    if (track) {

      track.removeAttribute('style');
    }


    section
      .querySelectorAll(
        '.skyline-circles__slide'
      )
      .forEach(function (slide) {

        slide.removeAttribute('style');

      });
  }



  /* =========================================================
     DESTROY SWIPER
  ========================================================= */

  function destroySwiper(section) {

    if (
      section._skylineSwiper &&
      !section._skylineSwiper.destroyed
    ) {

      section._skylineSwiper.destroy(
        true,
        true
      );
    }


    section._skylineSwiper = null;


    section.classList.remove(
      'skyline-circles--slider-active'
    );


    clearSwiperStyles(section);
  }



  /* =========================================================
     UPDATE SWIPER
  ========================================================= */

  function updateSwiper(section) {

    const swiper =
      section._skylineSwiper;


    if (
      !swiper ||
      swiper.destroyed
    ) {
      return;
    }


    swiper.params.slidesPerView =
      getSlidesPerView(section);


    swiper.params.spaceBetween =
      getSpaceBetween(section);


    swiper.updateSize();

    swiper.updateSlides();

    swiper.updateProgress();

    swiper.updateSlidesClasses();

    swiper.update();
  }



  /* =========================================================
     CREATE / SYNC SECTION
  ========================================================= */

  async function syncSection(section) {

    if (
      !section ||
      !document.documentElement.contains(
        section
      )
    ) {
      return;
    }


    const slider =
      section.querySelector(
        '[data-swiper]'
      );


    if (!slider) {
      revealSection(section);

      return;
    }


    /* =====================================================
       GRID MODE
       No delayed fade is needed here.
    ===================================================== */

    if (!needsSlider(section)) {

      destroySwiper(section);

      revealSection(section);

      return;
    }


    /* =====================================================
       ALREADY INITIALIZED
    ===================================================== */

    if (
      section._skylineSwiper &&
      !section._skylineSwiper.destroyed
    ) {

      updateSwiper(section);


      if (
        !section.classList.contains(
          'skyline-circles--visual-ready'
        )
      ) {

        /* Promote the first visible images, but do not delay the reveal. */
        waitForVisibleImages(
          section
        );


        revealSection(
          section
        );
      }


      return;
    }


    /*
     * Slider mode is server-rendered as a correctly-sized flex row.
     * Keep that fallback visible at near-full opacity while Swiper settles,
     * so there is no empty white gap.
     */
    setVisualLoading(
      section
    );


    try {

      await loadSwiper();

    } catch (error) {

      console.error(
        '[Skyline collection circles]',
        error
      );


      /*
       * Never leave content invisible
       * if the CDN fails.
       */
      revealSection(
        section
      );


      return;
    }


    /*
     * User may resize while
     * Swiper is loading.
     */
    if (
      !needsSlider(section) ||
      !document.documentElement.contains(
        section
      )
    ) {

      revealSection(
        section
      );


      return;
    }


    const prev =
      section.querySelector(
        '[data-prev]'
      );


    const next =
      section.querySelector(
        '[data-next]'
      );


    const pagination =
      section.querySelector(
        '[data-pagination]'
      );


    const slideCount =
      section.querySelectorAll(
        '.skyline-circles__slide'
      ).length;


    const slidesPerView =
      getSlidesPerView(
        section
      );


    /*
     * Add slider-active immediately before Swiper writes its widths.
     * The fallback is already close to the final layout, so the switch is subtle.
     */
    section.classList.add(
      'skyline-circles--slider-active'
    );


    section._skylineSwiper =
      new window.Swiper(
        slider,
        {

          slidesPerView:
            slidesPerView,

          spaceBetween:
            getSpaceBetween(section),

          speed: 450,

          watchOverflow: true,

          grabCursor: true,

          observer: true,

          observeParents: true,

          resizeObserver: true,

          roundLengths: true,

          loop:
            section.dataset.loop ===
              'true' &&
            slideCount >
              Math.ceil(
                slidesPerView
              ),


          navigation:
            prev && next
              ? {
                  prevEl: prev,
                  nextEl: next
                }
              : false,


          pagination:
            pagination
              ? {
                  el: pagination,
                  clickable: true
                }
              : false,


          autoplay:
            section.dataset.autoplay ===
                'true' &&
            slideCount >
              Math.ceil(
                slidesPerView
              )
              ? {

                  delay:
                    Number(
                      section.dataset
                        .autoplayDelay
                    ) || 5000,

                  disableOnInteraction:
                    false,

                  pauseOnMouseEnter:
                    true

                }
              : false
        }
      );


    /*
     * Let Swiper write final sizes, then reveal on the next paint.
     */
    window.requestAnimationFrame(
      function () {

        if (
          section._skylineSwiper &&
          !section._skylineSwiper.destroyed
        ) {

          updateSwiper(
            section
          );
        }

      }
    );


    /*
     * Reveal immediately after Swiper has its sizing.
     * Visible images are promoted/decode in the background so they cannot
     * hold the whole section invisible.
     */
    waitForVisibleImages(
      section
    );


    revealSection(
      section
    );
  }



  /* =========================================================
     RESIZE OBSERVER
  ========================================================= */

  function observeSection(section) {

    if (
      section._skylineResizeObserver
    ) {
      return;
    }


    const slider =
      section.querySelector(
        '[data-swiper]'
      );


    if (
      !slider ||
      !window.ResizeObserver
    ) {
      return;
    }


    section._skylineResizeObserver =
      new ResizeObserver(function () {

        window.clearTimeout(
          section._skylineResizeTimer
        );


        section._skylineResizeTimer =
          window.setTimeout(
            function () {

              syncSection(section);

            },
            100
          );

      });


    section
      ._skylineResizeObserver
      .observe(slider);
  }



  /* =========================================================
     INIT SECTION
  ========================================================= */

  function initSection(section) {

    if (!section) {
      return;
    }


    managedSections.add(section);


    /*
     * CSS already knows slider/grid from server-rendered
     * section classes. This JS state keeps Theme Editor
     * reloads and viewport layout changes equally smooth.
     */
    if (needsSlider(section)) {

      setVisualLoading(
        section
      );

    } else {

      section.classList.remove(
        'skyline-circles--visual-loading'
      );


      section.classList.add(
        'skyline-circles--visual-ready'
      );
    }


    observeSection(section);


    syncSection(section);


    /*
     * Safety fallback:
     * content must never remain invisible.
     */
    window.clearTimeout(
      section._skylineVisualSafetyTimer
    );


    section._skylineVisualSafetyTimer =
      window.setTimeout(
        function () {

          if (
            !section.classList.contains(
              'skyline-circles--visual-ready'
            )
          ) {

            revealSection(
              section
            );
          }

        },
        500
      );
  }



  /* =========================================================
     BOOT
  ========================================================= */

  function boot(root) {

    if (!root) {
      return;
    }


    if (
      root.matches &&
      root.matches(
        '[data-skyline-circles]'
      )
    ) {

      initSection(root);
    }


    if (root.querySelectorAll) {

      root
        .querySelectorAll(
          '[data-skyline-circles]'
        )
        .forEach(
          function (section) {

            initSection(section);

          }
        );
    }
  }


  window.__skylineCirclesBoot =
    boot;



  /* =========================================================
     INITIAL LOAD
  ========================================================= */

  boot(document);



  /* =========================================================
     WINDOW RESIZE FALLBACK
  ========================================================= */

  let resizeTimer = null;


  window.addEventListener(
    'resize',
    function () {

      window.clearTimeout(
        resizeTimer
      );


      resizeTimer =
        window.setTimeout(
          function () {

            managedSections.forEach(
              function (section) {

                syncSection(section);

              }
            );

          },
          120
        );

    }
  );



  /* =========================================================
     SHOPIFY SECTION LOAD
  ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      boot(event.target);

    }
  );



  /* =========================================================
     SHOPIFY SECTION UNLOAD
  ========================================================= */

  document.addEventListener(
    'shopify:section:unload',
    function (event) {

      let section = null;


      if (
        event.target.matches &&
        event.target.matches(
          '[data-skyline-circles]'
        )
      ) {

        section =
          event.target;

      } else if (
        event.target.querySelector
      ) {

        section =
          event.target.querySelector(
            '[data-skyline-circles]'
          );
      }


      if (!section) {
        return;
      }


      destroySwiper(section);


      if (
        section._skylineResizeObserver
      ) {

        section
          ._skylineResizeObserver
          .disconnect();


        section._skylineResizeObserver =
          null;
      }


      window.clearTimeout(
        section._skylineResizeTimer
      );


      window.clearTimeout(
        section._skylineVisualSafetyTimer
      );


      managedSections.delete(
        section
      );

    }
  );



  /* =========================================================
     SHOPIFY BLOCK SELECT
  ========================================================= */

  document.addEventListener(
    'shopify:block:select',
    function (event) {

      const section =
        event.target.closest
          ? event.target.closest(
              '[data-skyline-circles]'
            )
          : null;


      if (
        !section ||
        !section._skylineSwiper ||
        section._skylineSwiper.destroyed
      ) {
        return;
      }


      const slide =
        event.target.closest(
          '.skyline-circles__slide'
        );


      if (!slide) {
        return;
      }


      const slides =
        Array.from(
          section.querySelectorAll(
            '.skyline-circles__slide:not(.swiper-slide-duplicate)'
          )
        );


      const index =
        slides.indexOf(slide);


      if (index < 0) {
        return;
      }


      if (
        section._skylineSwiper.params
          .loop &&
        section._skylineSwiper
          .slideToLoop
      ) {

        section
          ._skylineSwiper
          .slideToLoop(index);

      } else {

        section
          ._skylineSwiper
          .slideTo(index);
      }

    }
  );
}


/* =========================================================
   DOCUMENT LOAD INITIALIZATION
========================================================= */

if (document.readyState === 'loading') {

  document.addEventListener(
    'DOMContentLoaded',
    skylineCirclesDocumentLoad,
    {
      once: true
    }
  );

} else {

  skylineCirclesDocumentLoad();
}
